import React, { Component } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { QUICK_SUGGESTIONS } from '../../constants/textConstants';

export default class QuickChatBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderBoxChat = (msg) => {
    return (
      <View style={css.messageBox}>
        <Text
          onPress={() => {
            this.sendQuickMessagetoOperator(msg);
          }}
          style={css.text}
        >
          {msg}
        </Text>
      </View>
    );
  };

  sendQuickMessagetoOperator = (msg) => {
    this.props.onClickQuickmessages(msg);
  };
  RenderQuickMsgBoxes = (quickMessageType) => {
    let quickMessage = '';
    switch (quickMessageType) {
      case 'existingPolicy':
        quickMessage = QUICK_SUGGESTIONS.EXISTING_POLICY;
        break;
      case 'paymentFailed':
        quickMessage = QUICK_SUGGESTIONS.PAYMENT_FAILED;
        break;
      case 'quoteReject':
        quickMessage = QUICK_SUGGESTIONS.QUOTE_REJECT;
        break;
    }
    return <View>{this.renderBoxChat(quickMessage)}</View>;
  };

  render() {
    let reason =
      this.props.AllDetailsRooms[this.props.room] &&
      this.props.AllDetailsRooms[this.props.room].reason
        ? this.props.AllDetailsRooms[this.props.room].reason
        : '';

    return (
      reason && (
        <View style={css.outerView}>
          <View style={css.quickChatContainerView}>
            <Text style={css.headingQuickChat}>QUICK CHAT</Text>
            {this.RenderQuickMsgBoxes(reason)}
          </View>
        </View>
      )
    );
  }
}

const css = StyleSheet.create({
  headingQuickChat: {
    paddingTop: 10,
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
  },
  quickChatContainerView: {
    minHeight: 100,
    width: '100%',
    backgroundColor: '#cce0ff',
  },
  outerView: {
    margin: 10,
  },
  text: {
    fontFamily: 'SFProText',
    fontSize: 14,
    color: 'black',
  },
  messageBox: {
    padding: 10,
    backgroundColor: '#b3b3ff',
    minHeight: 40,
    margin: 10,
    maxWidth: 400,
    alignSelf: 'center',
  },
});
